export const verbiage = {
  unrecognizableFile: "Unable to recognize file.",
  fileNameFormatInvalid: "File name is invalid. File name must consist of a alphanumeric characters, underscores, or hyphens separated by a single period.",
  fileTooLarge: "File size is too large. Please upload a file that is less than 20MB.",
  fileNotSupported: "File type is not supported. Please upload a valid image, gif or PDF file.",
  unrecognizableFileExtension: "File name is missing an extension such as .pdf, .jpg, .jpeg, .png, or .gif.",
}

export default verbiage;